<template>
    <div class="rewards">
        <div v-if="active && loaded">
            <h3 class='mb-3'>My Studies Weekly Rewards Link</h3>
            <div class='card'>
                <div class='card-body'>
                    <div class="alert alert-info" role="alert">
                        Customize your page and start earning rewards just for sharing Studies Weekly with colleagues.  You'll earn rewards for making a difference!
                    </div>
                    <div class="form-group mb-0">
                        <div class="input-group">
                            <!-- <div class="input-group-prepend">
                                <span class="input-group-text">Your Affiliate Link:</span>
                            </div> -->
                            <input type="text" class="form-control" id="affiliate_link" v-model="customURL" readonly>
                            <div class="input-group-append">
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    v-clipboard:copy="customURL"
                                    v-clipboard:success="onCopy"
                                    v-clipboard:error="onCopyError"
                                    v-b-popover.hover="'Copy to Clipboard'"
                                >
                                    <font-awesome-icon :icon="['fad', 'clipboard']" />
                                </button>
                            </div>
                            <div class="input-group-append">
                                <a :href="customURL" class="btn btn-outline-secondary" v-b-popover.hover="'Open Affiliate Page'" target="_blank">
                                    <font-awesome-icon :icon="['fad', 'browser']" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="my-3">Rewards</h3>
            <div class="alert alert-info" role="alert">
                When they order you get redeemable rewards in $50 increments as Amazon Gift Cards.
            </div>
            <div class='row'>
                <div class='col-lg-6 mb-3'>
                    <div class='card'>
                        <h5 class='card-header text-center'>
                            Total Referred Sales
                        </h5>
                        <div class='card-body text-center'>
                            <h2>{{totalReferred | currency}}</h2>
                        </div>
                    </div>
                </div>
                <div class='col-lg-6 mb-3'>
                    <div class='card'>
                        <h5 class='card-header text-center'>
                            My Credit
                        </h5>
                        <div class='card-body text-center'>
                            <h2>{{storeCredit | currency}}</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="cardPosition == 1" class='card'>
                <h5 class='card-header text-center d-flex'>
                    <button class='btn btn-secondary btn-sm' disabled>
                        <font-awesome-icon :icon="['far', 'angle-left']" fixed-width />
                    </button>
                    <span class='mx-auto align-self-center'>Bronze</span>
                    <button class='btn btn-dark btn-sm' @click="cardPosition++">
                        <font-awesome-icon :icon="['far', 'angle-right']" fixed-width />
                    </button>
                </h5>
                <div class='card-body text-center'>
                    <div class="mb-3">
                        <font-awesome-layers class='fa-5x'>
                            <font-awesome-icon icon="circle" style="color: #cd7f32" />
                            <font-awesome-icon :icon="['fas', 'check']" class="text-white" transform="shrink-6" />
                        </font-awesome-layers>
                    </div>
                    <div class="mb-3">
                        <h6>Bronze Level Affiliate</h6>
                        <div>3% of referred sales up to $1800</div>
                        <template v-if="level == 1">
                            {{remaining | currency}} until Silver
                        </template>
                    </div>
                    <b-progress v-if="level == 1" :value="totalThisLevel" :max="goalThisLevel"></b-progress>
                    <b-progress v-if="level > 1" :value="1" :max="1"></b-progress>
                    <!-- <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="bronzeProgress"></div>
                    </div> -->
                </div>
            </div>

            <div class='card' v-if="cardPosition == 2">
                <h5 class='card-header text-center d-flex'>
                    <button class='btn btn-dark btn-sm' @click="cardPosition--">
                        <font-awesome-icon :icon="['far', 'angle-left']" fixed-width />
                    </button>
                    <span class='mx-auto align-self-center'>Silver</span>
                    <button class='btn btn-dark btn-sm' @click="cardPosition++">
                        <font-awesome-icon :icon="['far', 'angle-right']" fixed-width />
                    </button>
                </h5>
                <div class='card-body text-center'>
                    <div class="mb-3">
                        <font-awesome-layers class='fa-5x'>
                            <font-awesome-icon icon="circle" style="color: #c0c0c0"/>
                            <font-awesome-icon :icon="['fas', 'times']" class="text-white" transform="shrink-6" />
                        </font-awesome-layers>
                    </div>
                    <div class="mb-3">
                        <h6>Silver Level Affiliate</h6>
                        <div>5% of referred sales between $1800 and $5400</div>
                        <small v-if="level < 2">unlock silver to see progress</small>
                        <template v-if="level == 2">
                            {{remaining | currency}} until Gold
                        </template>
                    </div>
                    <b-progress v-if="level < 2" :value="0" :max="1"></b-progress>
                    <b-progress v-if="level == 2" :value="totalThisLevel" :max="goalThisLevel"></b-progress>
                    <b-progress v-if="level > 2" :value="1" :max="1"></b-progress>
                </div>
            </div>

            <div class='card' v-if="cardPosition == 3">
                <h5 class='card-header text-center d-flex'>
                    <button class='btn btn-dark btn-sm' @click="cardPosition--">
                        <font-awesome-icon :icon="['far', 'angle-left']" fixed-width />
                    </button>
                    <span class='mx-auto align-self-center'>Gold</span>
                    <button class='btn btn-dark btn-sm' @click="cardPosition++">
                        <font-awesome-icon :icon="['far', 'angle-right']" fixed-width />
                    </button>
                </h5>
                <div class='card-body text-center'>
                    <div class="mb-3">
                        <font-awesome-layers class='fa-5x'>
                            <font-awesome-icon icon="circle" style="color: #d4af37"/>
                            <font-awesome-icon :icon="['fas', 'times']" class="text-white" transform="shrink-6" />
                        </font-awesome-layers>
                    </div>
                    <div class="mb-3">
                        <h6>Gold Level Affiliate</h6>
                        <div>10% of referred sales above $10,000</div>
                        <small v-if="level < 3">unlock gold to see progress</small>
                        <template v-if="level == 3">
                            {{remaining | currency}} until Diamond
                        </template>
                    </div>
                    <b-progress v-if="level < 3" :value="0" :max="1"></b-progress>
                    <b-progress v-if="level == 3" :value="totalThisLevel" :max="goalThisLevel"></b-progress>
                    <b-progress v-if="level > 3" :value="1" :max="1"></b-progress>
                </div>
            </div>

            <div class='card' v-if="cardPosition == 4">
                <h5 class='card-header text-center d-flex'>
                    <button class='btn btn-dark btn-sm' @click="cardPosition--">
                        <font-awesome-icon :icon="['far', 'angle-left']" fixed-width />
                    </button>
                    <span class='mx-auto align-self-center'>Diamond</span>
                    <button class='btn btn-secondary btn-sm' disabled>
                        <font-awesome-icon :icon="['far', 'angle-right']" fixed-width />
                    </button>
                </h5>
                <div class='card-body text-center'>
                    <div class="mb-3">
                        <font-awesome-layers class='fa-5x'>
                            <font-awesome-icon icon="circle" style="color: #B9F2FF" />
                            <font-awesome-icon :icon="['fas', 'times']" class="text-white" transform="shrink-6"/>
                        </font-awesome-layers>
                    </div>
                    <div>
                        <h6>Diamond Level Affiliate</h6>
                        <div>10% of referred sales</div>
                        <div>+Residuals</div>
                    </div>
                </div>
            </div>

            <h4 class="my-3">My Referrals</h4>

            <table class='table table-bordered table-striped'>
                <thead class="bg-white">
                    <tr>
                        <th>Name</th>
                        <th width="1">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="sale in referredSales">
                        <td>{{sale.name}}</td>
                        <td>{{sale.amount | currency}}</td>
                    </tr>
                </tbody>
            </table>

            <h4 class="my-3">Leaderboard</h4>

            <table class='table table-bordered table-striped'>
                <thead class="bg-white">
                    <tr>
                        <th>Place</th>
                        <th>Name</th>
                        <th width="1">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-bind:class="{ 'table-success' : leader.me }" v-for="(leader, index) in leaders">
                        <td>{{index + 1}}</td>
                        <td>{{leader.name}}</td>
                        <td>{{leader.total | currency}}</td>
                    </tr>
                </tbody>
            </table>
        </div><!--End Main Section-->
        <div v-if="!active && loaded" class="col-lg-9 col-md-8 mb-3"><!--Inactive Section-->
            <div class="card">
                <h5 class="card-header">Affiliate Program</h5>
                <div class="card-body">
                    <p class="card-text">By activating the affiliate program on this account, you verify that you have read and agree to the terms of service.</p>
                    <button v-b-modal.tos-modal class='btn btn-secondary mr-2'>Review Terms</button>
                    <button class='btn btn-primary' @click='accept()'>Activate Affiliate Program</button>
                </div>
            </div>
            <b-modal size="xl" cancel-disabled id="tos-modal" title="Studies Weekly Affiliate Program TOS">
                <div v-html='tos' class="my-4">

                </div>
                <template v-slot:modal-footer="{ ok }">
                    <button class="btn btn-success" @click="ok()">OK</button>
                </template>
            </b-modal>
        </div>
        <div v-if="!loaded" class="col-lg-9 col-md-8 mb-3">
            <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>




export default {
    data: () => ({
        customURL: '',
        bronzeProgress: {
            width: '50%'
        },
        storeCredit: 0,
        active: false,
        cardPosition: 0,
        level: 0,
        referredSales: [],
        totalReferred: 0,
        totalThisLevel: 0,
        goalThisLevel: 1,
        loaded: false,
        leaders: [
        ],
        tos: ""
    }),
    computed: {
        remaining: function () {
            return this.goalThisLevel - this.totalThisLevel
        }
    },
    methods: {
        getTOS () {
            this.busy = true
            this.$http({
                'url': 'dashboard/affiliate/terms',
                'method': 'GET',
            }).then((response) => {
                this.busy = false
                this.tos = response.data.result.terms
            }).catch((error) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Whoops, something went wrong.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })               
            })
        },
        accept () {
            this.$http({
                'url': 'dashboard/affiliate/accept',
                'method': 'post'
            }).then((response) => {
                if (response.data.success) {
                    this.active = true
                }
            })            
        },
        onCopy () {
            this.$swal({
                toast: true,
                html: 'Affiliate link copied',
                type: 'success',
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000
            })
        },
        onCopyError () {
            this.$swal({
                html: 'Link did not copy correctly. Please try again.',
                type: 'error'
            })
        },
    },
    mounted () {
        this.getTOS()
        this.customURL = window.location.origin + "/t/" + this.$auth.user().linkCode
        this.$http({
            'url': 'dashboard/affiliate/data',
            'method': 'get'
        }).then((response) => {
            if (response.data.success) {
                this.totalReferred = response.data.data.totalReferred
                this.storeCredit = response.data.data.storeCredit
                this.referredSales = response.data.data.referrals
                this.level = response.data.data.level
                this.totalThisLevel = response.data.data.totalThisLevel
                this.goalThisLevel = response.data.data.salesGoalThisLevel
                this.leaders = response.data.data.leaders
                this.active = response.data.data.active == 1
            }
            this.loaded = true
        })
    }
}
</script>
